  
document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#gallery-slider', {
          padding     : { right: '0%' },
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints : {
              993: {
                  destroy: true,
              },
        },
      }).mount();
  });

    
document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#testimonials-slider', {
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints : {
              993: {
                  destroy: true,
              },
        },
      }).mount();
  });
